import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class VendasVendedoresPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaOrdem, buscaAno, buscaMes, buscaUsuario } = this.props.filtros;

        if ((buscaAno) || (buscaMes)) {

            axios
                .get('/vendas/listaMetasVendedores', {
                    params: {
                        print: true,
                        campoOrdem: buscaOrdem.campo,
                        tipoOrdem: buscaOrdem.ordem,
                        ano: buscaAno,
                        mes: buscaMes,
                        usuario: buscaUsuario.key,
                    }
                })
                .then(response => {
                    const { data } = response;
                    this.setState({
                        listaRegistros: response.data.dados,
                        carregando: false,
                    });
                })
                .catch(erro => {
                    console.warn(erro);
                    this.setState({
                        carregando: false,
                    });
                });
        } else {
            this.setState({
                listaRegistros: [],
                carregando: false,
            });
        }

    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderValor01 = (vlr, registro) => {
        const meta = registro.vendas01 > registro.meta01 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor02 = (vlr, registro) => {
        const meta = registro.vendas02 > registro.meta02 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor03 = (vlr, registro) => {
        const meta = registro.vendas03 > registro.meta03 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor04 = (vlr, registro) => {
        const meta = registro.vendas04 > registro.meta04 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor05 = (vlr, registro) => {
        const meta = registro.vendas05 > registro.meta05 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor06 = (vlr, registro) => {
        const meta = registro.vendas06 > registro.meta06 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor07 = (vlr, registro) => {
        const meta = registro.vendas07 > registro.meta07 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor08 = (vlr, registro) => {
        const meta = registro.vendas08 > registro.meta08 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor09 = (vlr, registro) => {
        const meta = registro.vendas09 > registro.meta09 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor10 = (vlr, registro) => {
        const meta = registro.vendas10 > registro.meta10 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor11 = (vlr, registro) => {
        const meta = registro.vendas11 > registro.meta11 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderValor12 = (vlr, registro) => {
        const meta = registro.vendas12 > registro.meta12 ? 1 : 0;
        return (
            <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }



    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                    width={1400}
                >
                    <div >
                        <div className="titulo">
                            Vendas por Vendedores
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Período: </span>
                                <span>{this.props.buscaMes + '/' + this.props.buscaAno}</span>
                            </Col>
                        </Row>


                        {this.props.buscaMes ? (
                            <Row>
                                <div style={{ marginTop: 10 }}>
                                    <Table
                                        pagination={false}
                                        onChange={this.onTabelaChange}
                                        loading={{
                                            spinning: carregando,
                                            tip: 'Carregando. Aguarde...',
                                            size: "large"
                                        }}
                                        dataSource={listaRegistros}
                                        // scroll={{ x: 600 }}
                                        rowKey={(registro => registro.usu_cpf)}
                                    >
                                        <Column
                                            key="usu_cpf"
                                            dataIndex="usu_cpf"
                                            title="Vendedor"
                                            width={80}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="usu_nome"
                                            dataIndex="usu_nome"
                                            title="Nome"
                                            width={300}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="vendasTotais"
                                            dataIndex="vendasTotais"
                                            title="Vendas"
                                            render={this.renderValor}
                                            width={80}
                                            align="right"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="meta"
                                            dataIndex="meta"
                                            title="Meta"
                                            render={this.renderValor}
                                            width={80}
                                            align="right"
                                            className="listaCadastro"
                                        />
                                    </Table>
                                </div>
                            </Row>

                        ) : (
                                <Row>
                                    <div style={{ marginTop: 10 }}>
                                        <Table
                                            pagination={false}
                                            onChange={this.onTabelaChange}
                                            loading={{
                                                spinning: carregando,
                                                tip: 'Carregando. Aguarde...',
                                                size: "large"
                                            }}
                                            dataSource={listaRegistros}
                                            // scroll={{ x: 600 }}
                                            rowKey={(registro => registro.usu_cpf)}
                                        >
                                            <Column
                                                key="usu_nome"
                                                dataIndex="usu_nome"
                                                title="Nome"
                                                width={100}
                                                align="left"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas01"
                                                dataIndex="vendas01"
                                                title="Jan"
                                                render={this.renderValor01}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas02"
                                                dataIndex="vendas02"
                                                title="Fev"
                                                render={this.renderValor02}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas03"
                                                dataIndex="vendas03"
                                                title="Mar"
                                                render={this.renderValor03}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas04"
                                                dataIndex="vendas04"
                                                title="Abr"
                                                render={this.renderValor04}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas05"
                                                dataIndex="vendas05"
                                                title="Mai"
                                                render={this.renderValor05}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas06"
                                                dataIndex="vendas06"
                                                title="Jun"
                                                render={this.renderValor06}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas07"
                                                dataIndex="vendas07"
                                                title="Jul"
                                                render={this.renderValor07}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas08"
                                                dataIndex="vendas08"
                                                title="Ago"
                                                render={this.renderValor08}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas09"
                                                dataIndex="vendas09"
                                                title="Set"
                                                render={this.renderValor09}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas10"
                                                dataIndex="vendas10"
                                                title="Out"
                                                render={this.renderValor10}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas11"
                                                dataIndex="vendas11"
                                                title="Nov"
                                                render={this.renderValor11}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="vendas12"
                                                dataIndex="vendas12"
                                                title="Dez"
                                                render={this.renderValor12}
                                                width={90}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                        </Table>
                                    </div>
                                </Row>
                            )}
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default VendasVendedoresPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/VendasVendedoresPrintModal.js